import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";

const FlayoutFilterLink = ({ children, years, handleYears }) => {
  const [mouseOn, setMpuseOn] = useState(false);
  return (
    <>
      <div
        onMouseEnter={() => setMpuseOn(true)}
        onMouseLeave={() => setMpuseOn(false)}
        // onClick={() => setMpuseOn((prev) => !prev)}
        className="relative"
      >
        <div className="flex items-center justify-center gap-1">
          <p>{children}</p>
          <ChevronRightIcon
            className={`relative top-[1px] h-4 w-4 stroke-current transition-all duration-300 ${mouseOn && "-rotate-90"}`}
          />
        </div>
        <AnimatePresence>
          {mouseOn && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35, ease: "easeOut" }}
              style={{ x: "-50%" }}
              className="absolute -top-[4.8rem] left-1/2 w-fit -translate-x-1/2 cursor-default rounded-md border px-3 py-2"
            >
              <div className="absolute left-0 top-[2.7rem] h-7 w-full bg-transparent"></div>
              <div className="space-y-3">
                <div className="flex justify-center gap-6 text-black">
                  {years.map((item, index) => {
                    return (
                      <div
                        key={item.item + index}
                        className={`flex cursor-pointer items-center gap-1 border border-visBlue border-opacity-90 px-5 py-1 ${item.checked && "bg-visBlue bg-opacity-90 text-white"} transition-all duration-300`}
                        onClick={(e) => handleYears(e, index)}
                      >
                        {item.item}
                        {/* <input
                          type="checkbox"
                          value={item.item}
                          name={item.item}
                          id={item.item}
                          checked={item.checked}
                          onChange={(e) => handleYears(e, index)}
                        /> */}
                        {/* <label htmlFor={item.item} className="font-normal cursor-pointer">
                          
                        </label> */}
                      </div>
                    );
                  })}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default FlayoutFilterLink;
